/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { DegreePlan_LearnerProgressState as LearnerProgressState } from '__generated__/graphql-types';

import type { Theme } from '@coursera/cds-core';
import { Grid, Tag, typography2 } from '@coursera/cds-core';
import { SuccessFilledIcon } from '@coursera/cds-icons';

import _t from 'i18n!nls/degree-home';

const CompletionStatusPadding: React.FC = ({ children }) => (
  <Grid
    css={(theme: Theme) =>
      css`
        margin-bottom: ${theme.spacing(8)};
      `
    }
  >
    {children}
  </Grid>
);

const styles = {
  plannedTag: css`
    span {
      ${typography2.subtitleMedium}
    }
  `,
};

interface Props {
  state: LearnerProgressState;
  showPlannedCourses?: boolean;
}

/** A tag indicating a summary of the learner's progress on a course */
const CompletionStatus: React.VFC<Props> = ({ state }) => {
  switch (state) {
    case LearnerProgressState.InProgress:
      return (
        <CompletionStatusPadding>
          <Tag variant="status" priority="primary" color="highlight1">
            {_t('In Progress')}
          </Tag>
        </CompletionStatusPadding>
      );
    case LearnerProgressState.Completed:
      return (
        <CompletionStatusPadding>
          <Tag variant="status" priority="primary" color="success" icon={<SuccessFilledIcon />}>
            {_t('Complete')}
          </Tag>
        </CompletionStatusPadding>
      );
    case LearnerProgressState.Planned:
      return (
        <CompletionStatusPadding>
          {/* https://coursera.slack.com/archives/C058TNFJMT3/p1701287374608129: variant is category on purpose */}
          <Tag variant="category" priority="primary" color="highlight2" css={styles.plannedTag}>
            {_t('Added to plan')}
          </Tag>
        </CompletionStatusPadding>
      );
    case LearnerProgressState.NotStarted:
    default:
      return null;
  }
};

export default CompletionStatus;
